<template>
    <div class="speakers-list-wrapper">
        <div class="speakers-list-item" v-for="item in guests" :key="item.id">
            <router-link :to="{path: '/speakers/' + item.id, query: {lan: lang}}">
                <div class="img">
                    <img :src="item.imgUrl" alt="">
                </div>
                <p class="name">
                    {{item.name}}
                </p>
                <p class="desc">
                    {{item.title}}
                </p>
            </router-link>
        </div>
    </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
    name: 'SpeakersList',
    props: ['guests'],
    computed: {
        ...mapState(['lang'])
    }
}
</script>

<style lang="scss">
    .speakers-list-wrapper {
        padding: 4.63vw 0 0 2.593vw;
        display: flex;
        flex-wrap: wrap;
        font-size: 0;
        .speakers-list-item {
            margin: 0 4.63vw 4.63vw 0;
            width: 25.463vw;
            &:nth-of-type(3n) {
                margin-right: 0;
            }
            a {
                display: block;
                text-decoration: none;
            }
            .name {
                font-weight: bold;
                color: #050505;
                font-size: 4.074vw;
                line-height: 1.4;
                text-align: center;
                margin: 2.222vw 0 1.389vw;
                word-wrap: break-word;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
            }
            .desc {
                color: #050505;
                font-size: 3.519vw;
                text-align: center;
                line-height: 1.4;
                word-wrap: break-word;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
            }
        }
    }
</style>
